<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    @select="v=>$emit('select',v)"
    placeholder="请选择账号类型"
    :clearable="clearable"
    idKey="AccountTypeId"
    labelKey="AccountType"
    :get-data-func="getDataFunc"
  />
</template>
<script>
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  components: { commonSelect },
  data() {
    return {
      api: require("@/api/ba/accountType").default,
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.list({ Status: 1 }).then((res) => {
          resolve(res);
        });
      });
    },
  },
};
</script>

